import React from 'react';
import PropTypes from 'prop-types';
import { SyncOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import styles from './team-balance-card.module.scss';

/**
 * TeamBalanceCard Component
 *
 * A reusable component that displays team members' lead distribution with visual bars.
 *
 * @param {Object} props - Component props
 * @param {Function} props.onRefresh - Function to call when refresh button is clicked
 * @param {string} props.title - Optional title for the card (defaults to "Current Team Balance")
 */
export const TeamBalanceCard = ({ Icon, onRefresh, loading, title, children }) => {
  return (
    <div className={styles.card_container}>
      <div className={styles.card_header}>
        <div className={styles.header_left}>
          {Icon && <Icon className={styles.header_icon} />}
          <h3 className={styles.header_title}>{title}</h3>
        </div>
        <Button loading={loading} icon={<SyncOutlined />} onClick={onRefresh} className={styles.refresh_button}>
          Refresh
        </Button>
      </div>
      <div className={styles.card_content}>{children}</div>
    </div>
  );
};

TeamBalanceCard.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  title: PropTypes.string,
};
